// app/packs/controllers/chart/variants/profile_ring_variant.js
import merge from 'lodash.merge'

export const ProfileRingVariant = {
  chartType: 'doughnut',

  applyDataDefaults(datasets) {
    datasets.forEach(dataset => {
      dataset.borderWidth = 0; 
      dataset.weight = 1;
    })
  },

  buildOptions(options = {}) {
    const doughnutOverrides = {
      cutout: '68%', // FEEDBACK UPDATE: Decreased from 76% to 68% to increase circle color track thickness
      responsive: true,
      maintainAspectRatio: false,
      animation: false,
      scales: {
        x: { display: false },
        y: { display: false }
      },
      plugins: {
        title: { display: false },
        tooltip: {
          enabled: true,
          backgroundColor: "#111827",
          titleColor: "#FFFFFF",
          bodyColor: "#FFFFFF",
          padding: 12,
          displayColors: false
        },
        legend: { display: false }
      },
      layout: {
        padding: 0
      }
    }
    return merge({}, doughnutOverrides, options)
  },

  centerTextPlugin(scoreValue) {
    return {
      id: 'centerText',
      afterDraw(chart) {
        const { ctx, width, height } = chart
        ctx.save()
        
        // Dynamic clean font sizing scaling
        const fontSize = Math.max(13, Math.round(width * 0.26))
        
        ctx.font = `300 ${fontSize}px 'Roboto', sans-serif`
        ctx.fillStyle = '#EE6840' 
        
        // PERFECT CENTERING ANCHORS
        ctx.textAlign = 'center'
        ctx.textBaseline = 'middle'
        
        const centerX = width / 2
        const centerY = (height / 2) + 1.5
        
        ctx.fillText(scoreValue, centerX, centerY)
        ctx.restore()
      }
    }
  }
}